// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const fasDistributeSpacingVertical: CreateIconOptions = {
  "displayName": "FASDistributeSpacingVertical",
  "viewBox": "0, 0, 512, 512",
  "d": "M0 56C0 42.7 10.7 32 24 32l464 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 80C10.7 80 0 69.3 0 56zM96 208c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-224 0c-26.5 0-48-21.5-48-48l0-96zM24 432l464 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
};
